import React, { ComponentType, ElementType, forwardRef } from 'react'
import { Field, FieldProps } from 'formik'

export type FormikFieldProps = {
  className?: string
  name?: string
  Component: ComponentType<any> | ElementType
  onChange?: (e: React.ChangeEvent<any>) => void
  hideError?: boolean
  [key: string]: any
}

const FormikField = forwardRef<any, FormikFieldProps>(
  ({ name, Component, hideError, ...rest }, ref) => {
    return (
      <Field name={name} {...rest} innerRef={ref}>
        {({ field, meta }: FieldProps) => {
          const fieldError = meta.error
          const hasError = meta.touched && !!fieldError

          const onChange = (e: React.ChangeEvent<any>) => {
            field.onChange(e)
            rest?.onChange?.(e)
          }

          return (
            <Component
              {...rest}
              {...field}
              onChange={onChange}
              hasError={hasError}
              error={hasError && !hideError ? fieldError : undefined}
            />
          )
        }}
      </Field>
    )
  }
)

FormikField.displayName = 'FormikField'

export default FormikField
